import request from '@/utils/request'

/**
 * 查询单条甲方信息
 * @param {Object} param 参数对象（必传paId，可选communityId）
 * @returns {Promise} Promise对象
 */
export const getPartyAInfo = () => {
  return request({
    url: '/contract.GetPartyAInfoCmd', // 对应Cmd层的服务编码
    method: 'get',
  })
}

/**
 * 修改甲方信息
 * @param {Object} param 甲方信息参数（必传paId、partyAName等核心字段）
 * @returns {Promise} Promise对象
 */
export const updatePartyAInfo = (param) => {
  return request({
    url: '/contract.UpdatePartyAInfoCmd', // 对应Cmd层的服务编码
    method: 'post',
    data: param
  })
}